export const EDIT_PRODUCTION_SET_START_FROM_INDEX =
  'EDIT_PRODUCTION_SET_START_FROM_INDEX';
export const EDIT_PRODUCTION_SET_VIEW_PROD_RECORD_INDEX =
  'EDIT_PRODUCTION_SET_VIEW_PROD_RECORD_INDEX';
export const EDIT_PRODUCTION_FETCHING_PRODUCTION_RECORDS =
  'EDIT_PRODUCTION_FETCHING_PRODUCTION_RECORD';
export const EDIT_PRODUCTION_SET_ERROR = 'EDIT_PRODUCTION_SET_ERROR';
export const EDIT_PRODUCTION_CLEAR_ERROR = 'EDIT_PRODUCTION_CLEAR_ERROR';
export const EDIT_PRODUCTION_CLEAR_STATE = 'EDIT_PRODUCTION_CLEAR_STATE';

export const EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING =
  'EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING';
export const EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS =
  'EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS';
export const EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR =
  'EDIT_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR';

export const EDIT_PRODUCTION_SET_SAVE_PRODUCTION_RECORDS_SUCCESS =
  'EDIT_PRODUCTION_SET_SAVE_PRODUCTION_RECORDS_SUCCESS';
export const EDIT_PRODUCTION_SET_TEMPERATURES =
  'EDIT_PRODUCTION_SET_TEMPERATURES';
export const EDIT_PRODUCTION_SET_LOADED_RECORDS_MAP =
  'EDIT_PRODUCTION_SET_LOADED_RECORDS_MAP';
export const EDIT_PRODUCTION_SET_EXPANDED_RECIPES_BY_PROD_RECORD =
  'EDIT_PRODUCTION_SET_EXPANDED_RECIPES_BY_PROD_RECORD';

export const EDIT_PRODUCTION_RECIPE_LEFTOVERS_LOADING =
  'EDIT_PRODUCTION_RECIPE_LEFTOVERS_LOADING';
export const EDIT_PRODUCTION_SET_RECIPE_LEFTOVERS =
  'EDIT_PRODUCTION_SET_RECIPE_LEFTOVERS';
export const EDIT_PRODUCTION_RECIPE_LEFTOVERS_ERROR =
  'EDIT_PRODUCTION_RECIPE_LEFTOVERS_ERROR';

export const EDIT_PRODUCTION_START_OVER_LOADING =
  'EDIT_PRODUCTION_START_OVER_LOADING';
export const EDIT_PRODUCTION_START_OVER_SUCCESS =
  'EDIT_PRODUCTION_START_OVER_SUCCESS';
export const EDIT_PRODUCTION_START_OVER_ERROR =
  'EDIT_PRODUCTION_START_OVER_ERROR';

export const EDIT_PRODUCTION_FORM_INITIALIZE =
  'EDIT_PRODUCTION_FORM_INITIALIZE';
export const EDIT_PRODUCTION_CHANGE_MODAL_VISIBILITY =
  'EDIT_PRODUCTION_CHANGE_MODAL_VISIBILITY';
export const EDIT_PRODUCTION_UPDATE_PRODUCTION_PLAN =
  'EDIT_PRODUCTION_UPDATE_PRODUCTION_PLAN';



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/editproduction/types.js